import { ArrowRightLeft } from "lucide-react";
import { Label } from "../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { RESTAURANTS } from "../../constants";
import { isMain } from "../../lib/permissions";

// "From → To" pickers + a swap button. Restaurant managers can only flip
// direction within their own restaurant; main managers are unrestricted.
export default function TransferDirectionPicker({ user, fromR, toR, onFrom, onTo, onSwap }) {
  const lockedFrom = !isMain(user) && user.restaurant !== fromR;
  const lockedTo = !isMain(user) && user.restaurant !== toR;
  return (
    <div className="grid grid-cols-[1fr_auto_1fr] items-end gap-2">
      <div>
        <Label className="text-[10.5px] tracking-eyebrow uppercase text-[#0B1F3A]/60">From</Label>
        <Select value={fromR} onValueChange={onFrom} disabled={lockedFrom}>
          <SelectTrigger className="mt-1 bg-white border-[#E6E0D4]"><SelectValue /></SelectTrigger>
          <SelectContent>
            {RESTAURANTS.map((r) => (
              <SelectItem key={r.id} value={r.id}>{r.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <button
        type="button"
        onClick={onSwap}
        title="Swap"
        data-testid="transfer-swap-btn"
        className="h-10 w-10 rounded-full bg-white border border-[#E6E0D4] flex items-center justify-center hover:border-[#0B1F3A]/40 transition-colors mb-0.5"
      >
        <ArrowRightLeft size={16} />
      </button>
      <div>
        <Label className="text-[10.5px] tracking-eyebrow uppercase text-[#0B1F3A]/60">To</Label>
        <Select value={toR} onValueChange={onTo} disabled={lockedTo}>
          <SelectTrigger className="mt-1 bg-white border-[#E6E0D4]"><SelectValue /></SelectTrigger>
          <SelectContent>
            {RESTAURANTS.map((r) => (
              <SelectItem key={r.id} value={r.id}>{r.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
